/* Section-owned assets register once and mount independently for each instance. */
(() => {
  if (window.GrovaSections) return;
  const definitions = new Map();
  const mounted = new Map();

  function mount(name, definition, container = document) {
    const roots = [...container.querySelectorAll(definition.selector)];
    if (container.matches?.(definition.selector)) roots.unshift(container);
    roots.forEach((root) => {
      let instances = mounted.get(root);
      if (!instances) mounted.set(root, (instances = new Map()));
      if (instances.has(name)) return;
      const controller = new AbortController();
      const cleanups = new Set();
      const timers = new Set();
      const intervals = new Set();
      const destroy = () => {
        controller.abort();
        timers.forEach(clearTimeout);
        intervals.forEach(clearInterval);
        cleanups.forEach((cleanup) => cleanup());
        instances.delete(name);
        if (!instances.size) mounted.delete(root);
      };
      instances.set(name, destroy);
      try {
        definition.initialize(root, {
          on(target, event, handler, options = {}) {
            target.addEventListener(event, handler, {
              ...(typeof options === 'boolean' ? { capture: options } : options),
              signal: controller.signal,
            });
          },
          timeout(callback, delay) {
            const timer = setTimeout(() => {
              timers.delete(timer);
              callback();
            }, delay);
            timers.add(timer);
            return timer;
          },
          interval(callback, delay) {
            const timer = setInterval(callback, delay);
            intervals.add(timer);
            return timer;
          },
          cleanup(callback) { cleanups.add(callback); },
        });
      } catch (error) {
        destroy();
        console.error(`Unable to initialize ${name}`, error);
      }
    });
  }

  window.GrovaSections = {
    register(name, selector, initialize) {
      if (!definitions.has(name)) definitions.set(name, { selector, initialize });
      mount(name, definitions.get(name));
    },
  };
  document.addEventListener('shopify:section:load', (event) => {
    definitions.forEach((definition, name) => mount(name, definition, event.target));
  });
  document.addEventListener('shopify:section:unload', (event) => {
    mounted.forEach((instances, root) => {
      if (root === event.target || event.target.contains(root)) {
        [...instances.values()].forEach((destroy) => destroy());
      }
    });
  });
})();
